import { Component, OnInit, ViewChild, ElementRef, NgZone, ChangeDetectorRef, Input } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { Router } from '@angular/router';
import { SebmGoogleMap, SebmGoogleMapMarker } from 'angular2-google-maps/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ValidationService } from '../../services/validation.service';
import { MapsAPILoader ,LatLngBoundsLiteral,LatLngLiteral} from 'angular2-google-maps/core';
import { GoogleMapsAPIWrapper } from 'angular2-google-maps/core/services/google-maps-api-wrapper';
import { User } from '../../models/user';
import { LocalStorage } from '../../services/local-storage';
import { Campaign } from '../../models/compaign';
import { Error } from '../../models/error';
import { LoaderService } from '../../services/Spinner.service';
import { DatePickerOptions, DateModel } from 'ng2-datepicker';
import { IMyDpOptions, IMyDate ,IMyDateModel} from 'mydatepicker';
//import { PopupImageComponent } from './advertiser/popup/resetconfirm.component';
import { } from '@types/googlemaps';

declare var google: any;
declare var $: any;
@Component({
    selector: 'app-campaign',
    templateUrl: './payreceipt.component.html',
    styleUrls: ['./payreceipt.component.css'],
    providers: [SharedService, GoogleMapsAPIWrapper]
})

export class payreceiptComponent implements OnInit {
    getReceipt: any;
    today: number = Date.now();
    constructor(private localstorage: LocalStorage, private router: Router,){}
    ngOnInit() {
       var i=0;
    
         this.getReceipt = this.localstorage.getStorage("payreceipt");
           for(i=0;i<this.getReceipt.length;i++){
      this.getReceipt[i].price = (Math.round( this.getReceipt[i].price * 100) / 100).toFixed(2);
 
       }

         if(!this.getReceipt) {
             this.router.navigate(['advertiser/createcampaign']);
         }
    }
    dashboard() {
        this.localstorage.removeStorage("payreceipt");
        this.localstorage.removeStorage('campaignId');
        this.router.navigate(['advertiser/campaignlist']);
    }
    createCampaign() {
        this.localstorage.removeStorage("payreceipt");
        this.localstorage.removeStorage('campaignId');
        this.router.navigate(['advertiser/createcampaign']);
    }
}


// WEBPACK FOOTER //
// ./src/app/advertiser/compaign/payreceipt.component.ts